import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import "../App.css"; // if you want to add custom styles
import JoshuaCartoon from "../images/JoshBusinessCartoon-Photoroom.png";

export default function HomePage() {
  return (
    <Container style={{ alignContent: "center", textAlign: "center", padding: "2rem", margin: "10rem auto", backgroundColor: "#f8f9fa" }} className="py-5">
      <Row className="align-items-center mb-5 flex-column-reverse flex-md-row">
        <Col md={8}>
          <h1 className="mb-3"><strong>Junior Web Developer</strong></h1>
          <p className="lead align-items-center gap-2">
            Hi, I'm <strong>Joshua Pierson</strong> — an aspiring web developer with a background in IT support. I'm passionate about creating clean, responsive, and user-focused applications using technologies like HTML, JavaScript, and React. <span role="img" aria-label="wave">👋🏾</span>
          </p>
          <br />
          <a href="https://www.linkedin.com/in/joshua-pierson726" target="_blank" rel="noopener noreferrer" style={{ marginRight: "1rem" }}>
            <FontAwesomeIcon icon={faLinkedin} size="2x" className="text-primary linkFunctions" />
          </a>
          <a href="https://github.com/Joshua-Pierson" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faGithub} size="2x" className="text-dark linkFunctions" />
          </a>
          <Link to="/ContactPage" className="btn btn-primary linkFunctions getInTouch">Get in Touch</Link>
        </Col>
        <Col md={4} className="text-center ">
          <img
            src={JoshuaCartoon}
            alt="Joshua Pierson"
            className=""
            style={{ maxHeight: "250px", objectFit: "cover", }}
          />
        </Col>
      </Row>
    </Container>
  );
}